import React from "react";
import Section from "../components/Section";
import Card from "../components/Card";

function ClientsPage() {
  return (
    <div>
      <Section
        eyebrow="Who we serve"
        title="High-net-worth individuals & closely held businesses in New England."
        kicker="We stay close enough to truly know our clients, and focused enough to keep the work exceptional."
      >
        {/* EXISTING CLIENT CARDS */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: "1.25rem",
            marginBottom: "3rem",
          }}
        >
          <Card
            title="Founders & entrepreneurs"
            body="Owners navigating growth, liquidity events, and the transition from most-of-your-wealth-in-your-business to diversified, durable portfolios."
          />
          <Card
            title="Executives & professionals"
            body="Leaders with complex comp structures (equity, RSUs, bonuses) who need help turning income into long-term wealth."
          />
          <Card
            title="Multi-generational families"
            body="Families thinking about legacy, education, gifting, and how to talk about money across generations in a healthy way."
          />
        </div>
      </Section>

      {/* SAGE 4 (UBS) COMPLEX PROFILES SECTION */}
      <Section
        eyebrow="Complex Profiles"
        title="Profiles who value coordination and discretion."
        kicker="We excel when the planning extends across business, family, tax, and jurisdiction."
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: "1.25rem",
          }}
        >
          <Card
            title="Founders after a major liquidity event"
            body="Clients needing strategic, discreet guidance on managing sudden, concentrated wealth after a company sale or major funding round."
          />
          <Card
            title="Families with multi-entity or multi-state footprints"
            body="Clients whose balance sheets involve managing assets, trusts, and tax liabilities across multiple states or jurisdictions."
          />
          <Card
            title="Executives with complex compensation"
            body="Leaders managing RSUs, stock options, carried interest, and other structures requiring tax-optimized deployment."
          />
          <Card
            title="Retiring business owners"
            body="Clients transitioning the business into cash flow assets and navigating succession, gifting, and governance."
          />
        </div>
      </Section>
    </div>
  );
}

export default ClientsPage;
